import React, { useState, useEffect } from "react";
import useHttpRequests from "../../../hooks/useHttpRequests";
import { TableWithStickyHeader } from "../../uiControls/tableWithStickyHeader";
import { RoleUpdate } from "./roleUpdate";
import { ConfirmationDialog } from "../../common/confirmationDialog";
import { AddNew } from "../../uiControls/addNew";
import * as utils from "../../common/utils";

const roleColumns = [
  { label: "Role Type", keyField: "roleKey", dataField: "name" },
  {
    label: "Description",
    keyField: "roleKey",
    dataField: "description",
  },
  {
    label: "Default Menu",
    keyField: "roleKey",
    dataField: "menu",
  },
  {
    label: "Status",
    keyField: "roleKey",
    dataField: "active",
    minWidth: 20,
    maxWidth: 20,
  },
  {
    label: "",
    keyField: "roleKey",
    dataField: "roleKey",
    minWidth: 20,
    maxWidth: 20,
  },
];

const roleSearchColumns = ["name", "description", "menu"];

export const RoleConfig = () => {
  const [updateOpen, setUpdateOpen] = useState(false);
  const [defaultMenu, setDefaultMenu] = useState([]);
  const [menu, setMenu] = useState([]);
  const [roleEdit, setRoleEdit] = useState(null);
  const [roleAttributes, setRoleAttributes] = useState({
    roleKey: 0,
    name: "",
    description: "",
    active: true,
    defaultMenu: 0,
    defaultMenuTitle: {},
    menuList: [],
  });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [confirmationDialogAttributes, setConfirmationDialogAttributes] =
    useState({});

  const { sendRequest: fetchMenus } = useHttpRequests();
  const { sendRequest: fetchRoleDetails } = useHttpRequests();

  const roleEditHandler = (e, key) => {
    e.stopPropagation();
    if (updateOpen) {
      //alert("Are you sure to discard your changes?");
      //TODO: confirmation for data loss
      return false;
    }

    const getRoleDetails = (roleObj) => {
      if (!roleObj || !roleObj.isSuccess || roleObj.errorResponse) {
        console.log("Role fetch response returns error");
        return;
      }

      const selectedMenus = [];
      roleObj["menus"].forEach((obj) => {
        if (obj.children?.length > 0) {
          obj.children.forEach((childObj) => {
            selectedMenus.push(childObj["menuKey"]);
          });
        }
      });
      setRoleAttributes({
        roleKey: roleObj["role"]["roleKey"],
        name: roleObj["role"]["name"],
        description: roleObj["role"]["description"],
        active: roleObj["role"]["active"],
        defaultMenu: roleObj["role"]["defaultMenu"],
        defaultMenuTitle: utils.findStringById(
          defaultMenu,
          "value",
          roleObj["role"]["defaultMenu"]
        ),
        menuList: selectedMenus,
      });

      setRoleEdit(true);
      setUpdateOpen(true);
    };

    fetchRoleDetails(
      { url: "Roles/" + key, method: "GET", header: true },
      getRoleDetails
    );
  };

  const changeRoleStatus = (e, key, status, name) => {
    e.stopPropagation();
    if (updateOpen || dialogOpen) {
      return false;
    }
    setConfirmationDialogAttributes({
      title: "Role status change confirmation!",
      message:
        "Are you sure to mark " +
        (status ? "active" : "inactive") +
        " the " +
        name +
        "?",
      confirmText: "Yes",
      cancelText: "No",
      url: "Roles/",
      keyField: "roleKey",
      key: key,
      status: status,
      messageTitle: name,
    });
    setDialogOpen(true);
  };

  const getUrl = (params) => {
    return "Roles";
  };

  useEffect(() => {
    const getMenuResponse = (menuObj) => {
      if (!menuObj || !menuObj.isSuccess || menuObj.errorResponse) {
        console.log("Menu fetch response returns error");
        return;
      }
      const tempDefaultMenus = [];
      const menuOptions = [];
      menuObj["menus"].forEach((obj) => {
        const menuChildren = [];

        if (obj.children?.length > 0) {
          obj.children.forEach((childObj) => {
            tempDefaultMenus.push({
              value: childObj["menuKey"],
              label: obj["title"] + " > " + childObj["title"],
            });
            menuChildren.push({
              value: childObj["menuKey"],
              label: childObj["title"],
            });
          });
        }
        menuOptions.push({
          value: obj["menuKey"],
          label: obj["title"],
          children: menuChildren,
        });
      });

      setDefaultMenu(tempDefaultMenus);
      setMenu(menuOptions);
    };
    fetchMenus({ url: "Menus", method: "GET", header: true }, getMenuResponse);
  }, []);

  const roleDetailProps = {
    defaultMenu,
    menu,
    setUpdateOpen,
    roleEdit,
    setRoleEdit,
    roleAttributes,
  };

  return (
    <div
      style={{
        display: "flex",
        flexFlow: "column",
        height: "calc(100vh - 160px)",
      }}
    >
      <ConfirmationDialog
        open={dialogOpen}
        setDialogOpen={setDialogOpen}
        confirmationDialogAttributes={confirmationDialogAttributes}
      />
      <div
        style={{
          display: "flex",
          flexFlow: "column",
          gap: "20px",
          width: "100%",
        }}
      >
        {!updateOpen && (
          <>
            <TableWithStickyHeader
              pagging={false}
              columns={roleColumns}
              url={getUrl}
              sourceObj="roles"
              editHandler={roleEditHandler}
              updateOpen={updateOpen || dialogOpen}
              searchOnColumns={roleSearchColumns}
              changeStatus={changeRoleStatus}
              searchPlace="right"
            />

            <AddNew
              onClickCall={() => {
                setRoleAttributes({
                  roleKey: 0,
                  name: "",
                  description: "",
                  active: true,
                  defaultMenu: 0,
                  defaultMenuTitle: "",
                  menuList: [],
                });
                setUpdateOpen(true);
              }}
            />
          </>
        )}
      </div>

      {updateOpen && (
        <div
          style={{
            display: "flex",
            width: "100%",
          }}
        >
          <RoleUpdate {...roleDetailProps} />
        </div>
      )}
    </div>
  );
};
